module.exports = __webpack_public_path__ + "static/media/dead_battery_f1_sel.8fa81a9a.svg";